import { render, staticRenderFns } from "./GerenciarExercicios.vue?vue&type=template&id=0d70d725&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarExercicios.vue?vue&type=style&index=0&id=0d70d725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70d725",
  null
  
)

export default component.exports